/**
 * Nextcloud mark: a disk with the cloud cut out, so the rail color shows through.
 * Monochrome via currentColor, same treatment as the Drive rail icon.
 */

import { forwardRef, useId } from 'react';
import type { LucideProps } from 'lucide-react';
import { cn } from '@/lib/utils';

export const NextcloudIcon = forwardRef<SVGSVGElement, LucideProps>(function NextcloudIcon(
  { className, size, color, absoluteStrokeWidth, strokeWidth, ...props },
  ref,
) {
  void absoluteStrokeWidth
  void strokeWidth
  const dimension = typeof size === 'number' ? size : undefined;
  const maskId = `nextcloud-icon-${useId().replace(/:/g, '')}`;

  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      width={dimension}
      height={dimension}
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden
      {...props}
    >
      <mask id={maskId}>
        <rect width="24" height="24" fill="white" />
        <g transform="translate(5.4 5.4) scale(0.55)">
          <path
            fill="black"
            d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
          />
        </g>
      </mask>
      <circle cx="12" cy="12" r="9.25" fill={color ?? 'currentColor'} mask={`url(#${maskId})`} />
    </svg>
  );
});

NextcloudIcon.displayName = 'NextcloudIcon';
